module.exports = __webpack_public_path__ + "static/media/progress.4a2858b4.png";